import type { ReactNode } from "react";
import U2000RequireRole from "../u2000Core/components/controls/U2000RequireRole";
import U3107, { U3107ROLES } from "./U3107";
import U3107EquipmentList from "./components/U3107EquipmentList";
import U3107EquipmentForm from "./components/U3107EquipmentForm";

interface RouteObject {
  path?: string;
  index?: boolean;
  element?: ReactNode;
  children?: RouteObject[];
}

const U3107Routes: RouteObject[] = [
  {
    path: "U3107",
    element: <U2000RequireRole allowedRoles={[U3107ROLES.READ]} />,
    children: [
      {
        path: "",
        element: <U3107 />,
        children: [
          { index: true, element: <U3107EquipmentList /> },
          { path: ":id", element: <U3107EquipmentForm /> },
        ],
      },
    ],
  },
];

export default U3107Routes;
